// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1bLDg","item":"Sidebar_item__3PT_8","continueIcon":"Sidebar_continueIcon__3HXBk","active":"Sidebar_active__3Js8l","divider":"Sidebar_divider__2_4uZ"};